import React, {FC} from 'react';

import {SettingsDevelopersApplicationServersUrl} from '../../../../../models/url/settingsUrlModel';
import {DevelopersServersTableContainer} from '../../../tables/servers/developersServersTableContainer';
import {SettingsDevelopersApplicationConnectPageContainer} from './settingsDevelopersApplicationConnectPageContainer';

/*
 * Props.
 */

interface SettingsDevelopersApplicationServersPageProps {
  url: SettingsDevelopersApplicationServersUrl;
}

/*
 * Component.
 */

export const SettingsDevelopersApplicationServersPage: FC<SettingsDevelopersApplicationServersPageProps> = (
  props,
) => {
  const {url} = props;

  if (url.isConnecting || url.serverId) {
    return <SettingsDevelopersApplicationConnectPageContainer url={url} />;
  }
  return <DevelopersServersTableContainer url={url} />;
};
